// color-palette.ts

export const colorPalette: string[] = ['#02d7dc', '#584796', '#495356', '#000000', '#929292', '#5EA419', '#E2574C', '#D17517'];
